


























































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';
import { EventBus, EVENTS } from '@/services/EventBus';
import { fromLonLat, transform, transformExtent } from 'ol/proj.js';
import { Point } from 'ol/geom';
import { Feature } from 'ol';
import VectorSource from 'ol/source/Vector';
import LayerConfig from '@/models/map-context/LayerConfig';
import axios from 'axios';
import AlertMessage from '@/models/shared/AlertMessage';
import * as XLSX from 'xlsx';

@Component({
    props: {
    },
    components: {
    }
})
export default class LoadingFilePanel extends BaseComponent {
    importType: string = '';
    selectedLonColumn: string = '';
    selectedLatColumn: string = '';
    selectedAddressColumn: string = '';
    selectedPostalCodeColumn: string = '';
    selectedCityColumn: string = '';
    columns = [];
    csvContent:any;

    showCSVModal: boolean = false;

    csvFile: File | null = null;

    csvFileName: string = '';

    loading = false;

    errorMessage = '';


    mounted(){
        EventBus.$on(EVENTS.CSV_FILE_DROPPED, this.onFileDropped);
        EventBus.$on(EVENTS.XLSX_FILE_DROPPED, this.onFileDropped);
    }

    beforeDestroy() {
        EventBus.$off(EVENTS.CSV_FILE_DROPPED, this.onFileDropped);
        EventBus.$off(EVENTS.XLSX_FILE_DROPPED, this.onFileDropped);
    }

    detectLonLatColumns(headers: string[]): { lon: string, lat: string } {
        const lonKeywords = ['lon', 'long', 'longitude', 'x'];
        const latKeywords = ['lat', 'latitude', 'y'];
        
        let lonColumn = '';
        let latColumn = '';

        for (const header of headers) {
            const lowerHeader = header.toLowerCase();
            if (!lonColumn && lonKeywords.some(keyword => lowerHeader.includes(keyword))) {
                lonColumn = header;
            } else if (!latColumn && latKeywords.some(keyword => lowerHeader.includes(keyword))) {
                latColumn = header;
            }

            if (lonColumn && latColumn) break;
        }

        return { lon: lonColumn, lat: latColumn };
    }

    detectAddressColumns(headers: string[]): { address: string, postalCode: string, city: string } {
        const addressKeywords = ['adresse', 'adress', 'voie'];
        const postalCodeKeywords = ['code postal', 'cp', 'postal'];
        const cityKeywords = ['ville', 'city', 'commune'];
        
        let addressColumn = '';
        let postalCodeColumn = '';
        let cityColumn = '';

        for (const header of headers) {
            const lowerHeader = header.toLowerCase();
            if (!addressColumn && addressKeywords.some(keyword => lowerHeader.includes(keyword))) {
                addressColumn = header;
            } else if (!postalCodeColumn && postalCodeKeywords.some(keyword => lowerHeader.includes(keyword))) {
                postalCodeColumn = header;
            } else if (!cityColumn && cityKeywords.some(keyword => lowerHeader.includes(keyword))) {
                cityColumn = header;
            }

            if (addressColumn && postalCodeColumn && cityColumn) break;
        }

        return { address: addressColumn, postalCode: postalCodeColumn, city: cityColumn };
    }

    closeCSVModal() {
        this.$bvModal.hide('modal-lg')
        this.showCSVModal = false;
        this.csvFile = null;
        this.csvFileName = '';
        this.importType = '';
        this.selectedLonColumn = '';
        this.selectedLatColumn = '';
        this.selectedAddressColumn = '';
        this.selectedPostalCodeColumn = '';
        this.selectedCityColumn = '';
    }

    onFileDropped(file: File) {
        this.csvFile = file;
        this.csvFileName = file.name;
        this.showCSVModal = true;
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
  
        if (fileExtension === 'csv') {
            this.handleCsv(file);
        } else if (fileExtension === 'xlsx') {
            this.handleXlsx(file);
        } else {
            EventBus.$emit(EVENTS.ERROR, 'Type de fichier non pris en charge');
            this.closeCSVModal();
        }
    }

    
    get isImportButtonActive() {
        if (this.importType === 'coordinates') {
            return this.selectedLonColumn !== '' && this.selectedLatColumn !== '';
        } else if (this.importType === 'geocoding') {
            return this.selectedAddressColumn !== '' &&
                   this.selectedPostalCodeColumn !== '' &&
                   this.selectedCityColumn !== '';
        }
        return false;
    }

    handleCsv(file:File){
        const reader = new FileReader();
        reader.onload = (e) => {
            const csvContent = e.target?.result;
            if (csvContent) {
                this.csvContent = csvContent;
                this.columns = this.getCsvHeaders(csvContent);

                const { lon, lat } = this.detectLonLatColumns(this.columns);
                this.selectedLonColumn = lon;
                this.selectedLatColumn = lat;

                const { address, postalCode, city } = this.detectAddressColumns(this.columns);
                this.selectedAddressColumn = address;
                this.selectedPostalCodeColumn = postalCode;
                this.selectedCityColumn = city;

                if (this.selectedLonColumn && this.selectedLatColumn) {
                    this.importType = 'coordinates';
                }else if (this.selectedAddressColumn && this.selectedPostalCodeColumn && this.selectedCityColumn) {
                    this.importType = 'geocoding';
                }
            }
        }
        reader.onerror = (error) => {
            console.error('Error reading the file:', error);
        };

        reader.readAsText(file);
    }

    handleXlsx(file: File) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: 'array' });
            
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const csvContent = XLSX.utils.sheet_to_csv(worksheet, { FS: ';' });

            this.csvContent = csvContent;
            this.columns = this.getCsvHeaders(csvContent);
           
            const { lon, lat } = this.detectLonLatColumns(this.columns);
            this.selectedLonColumn = lon;
            this.selectedLatColumn = lat;

            const { address, postalCode, city } = this.detectAddressColumns(this.columns);
            this.selectedAddressColumn = address;
            this.selectedPostalCodeColumn = postalCode;
            this.selectedCityColumn = city;

            if (this.selectedLonColumn && this.selectedLatColumn) {
                this.importType = 'coordinates';
            } else if (this.selectedAddressColumn && this.selectedPostalCodeColumn && this.selectedCityColumn) {
                this.importType = 'geocoding';
            }
        };
        reader.onerror = (error) => {
            console.error('Error reading the file:', error);
        };

        reader.readAsArrayBuffer(file);
    }

    detectSeparator(csvContent:any) {
        const firstLine = csvContent.split('\n')[0];
        const commaCount = (firstLine.match(/,/g) || []).length;
        const semicolonCount = (firstLine.match(/;/g) || []).length;

        return commaCount > semicolonCount ? ',' : ';';
    }


    getCsvHeaders(csvContent:any) {
        const separator = this.detectSeparator(csvContent);
        const lines = csvContent.split('\n');
        return lines[0].trim().split(separator)
    }


    handleFileCoordinates(){
        if (this.csvContent) {
            const features = this.getFeaturesForCoordinates()

            if (features.length === 0){
                const message = `<i>Pas de données à importer</i>`;
                EventBus.$emit(EVENTS.WARNING, new AlertMessage({ label: message, autoHide: true }));
                return;
            }
            const vectorSource = new VectorSource({
                features: features,
            });

            let srcExtent = vectorSource.getExtent();
            srcExtent = transformExtent(srcExtent, 'EPSG:3857', "EPSG:4326");

            const newLayer = new LayerConfig({
                title: 'Import ' + this.csvFileName,
                type: 'Vector',
                visible: true,
                editable: false,
                layerProperties: [],
                boundingBoxEPSG4326: srcExtent,
            });

            try {
                this.contextService.getCurrentContext().getLayers().unshift(newLayer);
                this.getMapService().addLayer(newLayer);
            } catch (error:any) {
                newLayer.addError(error);
                console.log(error);
            }

            newLayer.getOlLayer().setSource(vectorSource);
            this.getMapService().zoomToExtent(vectorSource.getExtent())
            this.closeCSVModal()
            
            
        }
    }


    getFeaturesForCoordinates(){
        const features:any = [];
        const separator = this.detectSeparator(this.csvContent);
        this.loading = true;
    
        const lines = this.csvContent.split('\n');
        const headers = lines[0].trim().split(separator);

        const lonIndex = headers.indexOf(this.selectedLonColumn);
        const latIndex = headers.indexOf(this.selectedLatColumn);

        if (lonIndex === -1 || latIndex === -1) {
            console.error("Le fichier CSV ne contient pas les colonnes 'longitude' et 'latitude'.");
            return features;
        }
    
        for (let i = 0; i < lines.length; i++) {
            const values = lines[i].trim().split(separator);
            if (i == 0) {
                const checkHeader = values.map((x:any) => isNaN(x))
                if (checkHeader.indexOf(true) > -1 ) {
                    continue;
                }
            }

            const lon = parseFloat(values[lonIndex]);
            const lat = parseFloat(values[latIndex]);
            
        
            if (!isNaN(lon) && !isNaN(lat)) {
                const transformedCoords = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
                const point = new Point(transformedCoords);
              
                const properties: { [key: string]: string } = {
                    longitude: values[lonIndex],
                    latitude: values[latIndex]
                };

                headers.forEach((header:any, index:any) => {
                    if (index !== lonIndex && index !== latIndex) {
                        properties[header] = values[index];
                    }
                });

                const feature = new Feature({
                    geometry: point,
                    ...properties
                });
                features.push(feature);
            }
        }
        this.loading = false

        return features
    }


    async getFeaturesForAddress(){
        const separator = this.detectSeparator(this.csvContent);
        const features = [];

        const originalLines = this.csvContent.split('\n');
        const originalHeaders = originalLines[0].split(separator)
        
        const formData = new FormData();
        const blob = new Blob([this.csvContent], { type: 'text/csv' });//.replace(/,/g,";")
        formData.append('data', blob, this.csvFileName);
        this.loading = true;
        
        formData.append('columns', this.selectedAddressColumn);
        formData.append('columns', this.selectedPostalCodeColumn);
        formData.append('columns', this.selectedCityColumn);//.trim()

        try {
            const response = await axios.post('https://data.geopf.fr/geocodage/search/csv/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            // console.log('---------response---------');
            // console.log(response);
            // console.log(response.data);
            // console.log(typeof response.data);

            const dataString = new String(response.data);
            
            const lines = dataString.split('\n');
            const headers = lines[0].split(separator);

            const resultLatIndex = headers.indexOf('latitude');
            const resultLonIndex = headers.indexOf('longitude');
            const resultLabelIndex = headers.indexOf('result_label');


            for (let i = 1; i < lines.length; i++) {
                const values = lines[i].split(separator);
                const originalValues = originalLines[i].split(separator)
                if (values.length > resultLatIndex && values.length > resultLonIndex) {
                    const lat = parseFloat(values[resultLatIndex]);
                    const lon = parseFloat(values[resultLonIndex]);
                    if (!isNaN(lat) && !isNaN(lon)) {
                        const properties: { [key: string]: string } = {};
                        originalHeaders.forEach((header:any, index:any) => {
                            properties[header] = originalValues[index];
                        });
                        properties['geocodedLatitude'] = values[resultLatIndex];
                        properties['geocodedLongitude'] = values[resultLonIndex];
                        properties['geocodedAddress'] = values[resultLabelIndex];
                        // const feature = new Feature({
                        //     geometry: new Point(fromLonLat([lon, lat])),
                        //     address: values[headers.indexOf(this.selectedAddressColumn)],
                        //     postcode: values[headers.indexOf(this.selectedPostalCodeColumn)],
                        //     city: values[headers.indexOf(this.selectedCityColumn)],
                        //     geocodedAddress: values[resultLabelIndex]
                            
                        // });
                        const feature = new Feature({
                            geometry: new Point(fromLonLat([lon, lat])),
                            ...properties
                        });
                        features.push(feature);
                    }
                }
            }

            this.loading = false;

        } catch (error) {
            // console.error('Erreur lors du géocodage en masse:', error);
            this.errorMessage = 'Une erreur est survenue lors du géocodage en masse.';
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);

                    if (error.response.data) {
                        // this.errorMessage = `Erreur ${error.response.status}: ${error.response.data['message']}`;
                        this.errorMessage = JSON.stringify(error.response.data) 
                    } else {
                        // this.errorMessage = `Erreur ${error.response.status}: ${error.message}`;
                        this.errorMessage = error.message
                    }
                } else if (error.request) {
                    this.errorMessage = 'Aucune réponse reçue du serveur';
                } else {
                    this.errorMessage = error.message;
                }
            }
            this.loading = false;
            console.error(this.errorMessage);
            // EventBus.$emit(EVENTS.ERROR, 'https://api-adresse.data.gouv.fr/search/csv/ ' + errorMessage);
            // EventBus.$emit(EVENTS.ERROR, error + ' in https://api-adresse.data.gouv.fr/search/csv/');
            
        }

        // console.log('Features générées:', features);
        return features
    }


    async importData(){
        if (this.importType === 'coordinates') {
            this.importCoordinates();
        } else {
            await this.importGeocodedAddresses();
        }   
    }

    importCoordinates() {
        if (this.selectedLonColumn && 
            this.selectedLatColumn && 
            this.selectedLonColumn !== this.selectedLatColumn
        ) {
            this.handleFileCoordinates()
        } else{
            EventBus.$emit(EVENTS.ERROR, 'Vous avez sélectionné le même valeur champ pour longitude et latitude ');
            return;
        }
    }

    async importGeocodedAddresses(){
        const features = await this.getFeaturesForAddress();

        if (features.length === 0) {
            if (this.errorMessage !== '') {
                EventBus.$emit(EVENTS.ERROR, 'https://data.geopf.fr/geocodage/search/csv/ ' + '<pre> ' + this.errorMessage + ' </pre>');
                return;
            }
            console.log('No features to import');
            const message = `<i>Pas de données à importer</i>`;
            EventBus.$emit(EVENTS.WARNING, new AlertMessage({ label: message, autoHide: true }));
            // this.closeCSVModal()
            return;
        }

        const vectorSource = new VectorSource({
            features: features,
        });

        let srcExtent = vectorSource.getExtent();
        srcExtent = transformExtent(srcExtent, 'EPSG:3857', "EPSG:4326");

        const newLayer = new LayerConfig({
            title: 'Import ' + this.csvFileName,
            type: 'Vector',
            visible: true,
            editable: false,
            layerProperties: [],
            boundingBoxEPSG4326: srcExtent,
        });

        try {
            this.contextService.getCurrentContext().getLayers().unshift(newLayer);
            this.getMapService().addLayer(newLayer);
        } catch (error:any) {
            newLayer.addError(error);
            console.log(error);
        }

        newLayer.getOlLayer().setSource(vectorSource);
        this.getMapService().zoomToExtent(vectorSource.getExtent())
        this.closeCSVModal()
    }

}
